module.exports = __webpack_public_path__ + "images/icon-144.png";